import { Theme } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import v1Theme from "./v1";
declare module "@mui/material" {
  interface DefaultTheme extends Theme {}
}

declare module "@mui/material/styles" {
  interface Palette {
    text: {
      primary: string;
      secondary: string;
      brand: string;
      disabled: string;
      "system-green": string;
      "system-red": string;
      "btn-dark": string;
    };
    // Background
    brand: {
      primary: string;
      "primary-bg": string;
    };
    system: {
      green: string;
      "green-bg": string;
      "green-alarm": string;
      red: string;
      "red-bg": string;
      "red-alarm": string;
    };
    border: {
      dark: string;
      light: string;
      white: string;
    };
    surface: {
      light: string;
      "light-bg": string;
      silver: string;
      container: string;
      bg: string;
      "container-bg": string;
      black: string;
    };
  }

  interface PaletteOptions {
    text?: {
      primary?: string;
      secondary?: string;
      brand?: string;
      disabled?: string;
      "system-green"?: string;
      "system-red"?: string;
      "btn-dark"?: string;
    };
    // Background
    brand?: {
      primary?: string;
      "primary-bg"?: string;
    };
    system?: {
      green?: string;
      "green-bg"?: string;
      "green-alarm"?: string;
      red?: string;
      "red-bg"?: string;
      "red-alarm"?: string;
    };
    border?: {
      dark?: string;
      light?: string;
      white?: string;
    };
    surface?: {
      light?: string;
      "light-bg"?: string;
      silver?: string;
      container?: string;
      bg?: string;
      "container-bg"?: string;
      black?: string;
    };
  }

  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    "token-call-joined-sm": true;
    "token-call-joined-md": true;
    "token-call-trending-sm": true;
    "token-call-trending-md": true;
    "cabal-list-sm": true;
  }
}

// Override v1 theme
const theme = createTheme({
  ...v1Theme,
  palette: {
    ...v1Theme.palette,
    system: {
      ...v1Theme.palette.system,
    },
  },
});

export default theme;
